/* eslint jsx-a11y/aria-role: 0 */
import {connect} from 'react-redux';

import {getCartQuantity} from '../../reducers/cartReducer';
import {checkOutUri} from '../../config/uri';
import FloatingCart from './FloatingCart';
import {isProductsPage} from "../../helpers/urlParts";
import { pushWithQueryParams } from '../../services/uri';

const mapStateToProps = (state) => {
  return {
    router: state.router,
    cartQuantity: getCartQuantity(state),
    isProductPage: isProductsPage(state.router.location.pathname)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showCart: () => dispatch(pushWithQueryParams(checkOutUri))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(FloatingCart); 


// WEBPACK FOOTER //
// ./src/components/FloatingCart/FloatingCartContainer.jsx